import { render, staticRenderFns } from "./pageCard.vue?vue&type=template&id=4829457b&scoped=true"
import script from "./pageCard.vue?vue&type=script&lang=js"
export * from "./pageCard.vue?vue&type=script&lang=js"
import style0 from "./pageCard.vue?vue&type=style&index=0&id=4829457b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4829457b",
  null
  
)

export default component.exports